import React, {useState, useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Promo from './Promo';
import './Promo.scss';
import { useStateValue } from '../../../utilities/StateProvider';
import Cooler from '../Shows/Cooler';
import { api } from '../../../utilities/fetch';

export default function PromoList() {

    const [ promos, setPromos ] = useState([]);
    const [ cooler, setCooler ] = useState(null);
    const [ modal, setModal ] = useState(false);
    const [{ cart }, dispatch] = useStateValue();

    useEffect(() => {
        const getPromos = async () => {
            const promoList = await api.get(`promos`);
            setPromos(promoList.data);
        }
        getPromos();
    }, [])

    const toggleModal = () => {
        setModal(false);
    }

    const updateCooler = (value) => {
        const { show } = cart;

        setCooler(value);
        const newCart = {
            ...cart,
            show: {
                ...show,
                cooler: value
            }
        }

        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    const renderPromos = () => {
        promos.sort((a, b) => (a.id - b.id));
        return (
            promos.map((entry, index) => (<Col xs="6" md="3" key={index} className="promo-container"><Promo data={entry} setModal={setModal}/></Col>))
        )
    }

    return (
        <Container>
            <Row>
                {renderPromos()}
            </Row>
            <Cooler show={modal} submitCooler={updateCooler} onHide={toggleModal} defaultValue={cooler}/>
        </Container>
    )
}
